module.exports = __webpack_public_path__ + "static/media/Converting_a_Prospect_to_Account_Final.2e412498.mp4";